import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "wrapper1" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h2 class=\"com_mgb20 com_mgt100 com_fs26 com_medium1 com_center1\"> ただいまシステム運用時間外です </h2><p class=\"com_mgb50 com_reguler1 com_center1\"> 現在はシステム運用時間外のためご利用いただくことができません。 </p><p class=\"com_mgb50 com_fs17 com_reguler1 com_center1\"> システム運用時間<span class=\"com_fs26\"> 8:00〜21:00</span></p><p class=\"com_copyright1 com_mgt100\">© 2025 Kaunet</p>", 4)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.logoImage,
      alt: _ctx.altText,
      class: "with-kaunet_logo-overtime"
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}